module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAoBAMAAABHtxQFAAAAFVBMVEUAAAD///////////////////////9Iz20EAAAABnRSTlMAYPAw4NCNNKLTAAAAVElEQVQ4y2MYBYMNMAkACUYHrHKMiUBCyAC7RjEBBkZlII1dI0IbpkZBuDZMjUkGuOXUBHDKCRkm4tSmDHQqLm0GQKfi1MaASyOLAUhBAMMoGGQAALIxBVupzqbzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appRecommend/icon_close.png
// module id = tZ8R
// module chunks = 2